import {GetInteractionHandlersOptions} from '../index';
import {waypointFixedLayerIds} from '../../getSyncMapboxStyle/fixedLayerIds';

export default {

    getCursor: (interaction: MovingWaypointMapInteraction) => {
        if (interaction.subtype === 'hovering') {
            return 'grab';
        } else if (interaction.subtype === 'dragging') {
            return 'grabbing';
        } else {
            return 'default';
        }
    },

    onMouseDown: (event: mapboxgl.MapTouchEvent | mapboxgl.MapMouseEvent, {
        interaction,
        onInteractionChange,
    }: GetInteractionHandlersOptions<MovingWaypointMapInteraction>) => {

        if (interaction.subtype === 'hovering') {
            event.preventDefault();
            onInteractionChange({...interaction, subtype: 'dragging'});
        }
    },

    onMouseUp: (event: mapboxgl.MapTouchEvent | mapboxgl.MapMouseEvent, {
        interaction,
        onInteractionChange
    }: GetInteractionHandlersOptions<MovingWaypointMapInteraction>) => {

        if (interaction.subtype === 'dragging') {
            onInteractionChange({...interaction, subtype: 'normal'});
        }
    },

    onMouseMove: (event: mapboxgl.MapTouchEvent | mapboxgl.MapMouseEvent, {
        interaction,
        onInteractionChange,
        waypoints,
        waypointDispatcher,
        map,
    }: GetInteractionHandlersOptions<MovingWaypointMapInteraction>) => {
        if (!map) return;

        if (interaction.subtype === 'dragging') {
            waypointDispatcher({
                type: 'update',
                save: false,
                waypoint: {
                    ...waypoints[interaction.pointLocalId],
                    geometry: {
                        type: 'Point',
                        coordinates: event.lngLat.toArray()
                    }
                }
            });

        } else {
            const features = map.queryRenderedFeatures(event.point, {
                layers: [
                    waypointFixedLayerIds.localHighlight.pin,
                    waypointFixedLayerIds.localHighlight.circle,
                    waypointFixedLayerIds.localUser.circle,
                    waypointFixedLayerIds.localUser.pin,
                ].filter(id => map.getLayer(id))
            });

            if (features.length) {
                onInteractionChange({...interaction, subtype: 'hovering'});
            } else if (!features.length) {
                onInteractionChange({...interaction, subtype: 'normal'});
            }
        }
    },

    onMouseOut: () => {},

    onClick: () => {},

    onDblClick: () => {},
};
